angular.module 'app'
.controller 'InformationLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
